export default __webpack_public_path__ + "static/media/loading.d74979cc.gif";